import {is_function} from '../../../../Helpers/js/simple.functions';
import {CheckboxGroup} from '../CheckboxGroup';

export class MatrixMultiChoiceScale {
  constructor(question, scale, onChange) {
    this.question = question;
    this.id = scale.id;
    this.onChange = onChange;
    this.maxPerRow = scale.maxPerRow;
    this.maxPerCol = scale.maxPerCol;
    this.maxAnswers = scale.maxAnswers;

    var rows = Array.from(this.question.domNode.querySelectorAll('[role="group"]'));
    this.checkboxGroups = rows.map((row) => {
      var checkboxDomNodes = Array.from(row.querySelectorAll('[role="checkbox"][data-scale-id="' + this.id + '"]'));
      return new CheckboxGroup(checkboxDomNodes, this.answersChanged.bind(this), null, this.maxPerRow);
    });
  }

  answersChanged() {
    this.handleMaxAnswers();

    if (is_function(this.onChange)) {
      this.onChange();
    }
  }

  handleMaxAnswers() {
    if (!this.maxAnswers) {
      return;
    }

    var numAnswers = this.countAnswers();
    if (numAnswers >= this.maxAnswers) {
      this.checkboxGroups.map((group) => group.disableAllUncheckedCheckboxes());
    } else {
      this.checkboxGroups.map((group) => group.enableAllCheckboxes());
    }
  }

  countAnswers() {
    return this.checkboxGroups.reduce((count, group) => count + group.countAnswers(), 0);
  }
}
